<template>
  <div v-if="show" class="popup popup-cropper" @mousedown="closePopup">
    <div class="popup-container">
      <div class="popup-header">
        <h2 v-text="$t('common.t_img_preview')"></h2>
        <button class="icon close" @click.prevent="show = false"></button>
      </div>
      <div class="popup-body">
        <div class="cropper-wrap">
          <input
            ref="input"
            type="file"
            name="image"
            accept="image/.bmp, .jpg, .jpeg, .png"
            @change="setImage"
          />

          <div class="content">
            <section class="cropper-area">
              <div class="img-cropper">
                <vue-cropper
                  v-show="imgSrc"
                  ref="cropper"
                  :aspect-ratio="width / height"
                  :src="imgSrc"
                  :minCropBoxHeight="height"
                  preview=".preview"
                />
              </div>
            </section>

            <section class="preview-area">
              <p v-text="$t('movie_list.sub_btn_preview')"></p>
              <div class="preview" />
              <p v-show="false">Cropped Image</p>
              <div v-show="false" class="cropped-image">
                <img v-if="cropImg" :src="cropImg" alt="Cropped Image" />
                <div v-else class="crop-placeholder" />
              </div>
            </section>
          </div>

          <div class="button-box">
            <a
              href="#"
              role="button"
              class="upload-image-btn"
              @click.prevent="showFileChooser"
              v-text="$t('common.t_select_img')"
            ></a>
            <button
              class="button primary"
              @click.prevent="confirm()"
              v-text="$t('confirm')"
            ></button>
          </div>

          <div class="actions">
            <a
              href="#"
              role="button"
              class="btn zoom-in"
              @click.prevent="zoom(0.2)"
            >
              Zoom In
            </a>
            <a
              href="#"
              role="button"
              class="btn zoom-out"
              @click.prevent="zoom(-0.2)"
            >
              Zoom Out
            </a>
            <a
              href="#"
              role="button"
              class="btn crop"
              @click.prevent="cropImage"
            >
              Crop
            </a>
            <a
              ref="flipX"
              href="#"
              role="button"
              class="btn flip-x"
              @click.prevent="flipX"
            >
              Flip X
            </a>
            <a
              href="#"
              role="button"
              class="btn move-up"
              @click.prevent="move(0, -10)"
            >
              Move Up
            </a>
            <a
              ref="flipY"
              href="#"
              role="button"
              class="btn flip-y"
              @click.prevent="flipY"
            >
              Flip Y
            </a>
            <a
              href="#"
              role="button"
              class="btn move-left"
              @click.prevent="move(-10, 0)"
            >
              Move Left
            </a>
            <a href="#" role="button" class="btn reset" @click.prevent="reset">
              Reset
            </a>
            <a
              href="#"
              role="button"
              class="btn move-right"
              @click.prevent="move(10, 0)"
            >
              Move Right
            </a>
            <a
              href="#"
              role="button"
              class="btn rotate-minus"
              @click.prevent="rotate(-90)"
            >
              Rotate -90deg
            </a>
            <a
              href="#"
              role="button"
              class="btn move-down"
              @click.prevent="move(0, 10)"
            >
              Move Down
            </a>
            <a
              href="#"
              role="button"
              class="btn rotate-plus"
              @click.prevent="rotate(90)"
            >
              Rotate +90deg
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import EventBus from '@utils/bus';

export default {
  name: 'PopupCropper',
  components: {
    VueCropper,
  },
  props: {
    opened: false,
    previewTheme: '',
  },
  computed: {
    show: {
      get() {
        return this.opened;
      },
      set(value) {
        if (!value) {
          this.$emit('cropperPopupOnOff');
        }
      },
    },
  },
  data() {
    return {
      imgKey: 0,
      imgSrc: '',
      cropImg: '',
      data: null,
      exts: ['bmp', 'jpg', 'jpeg', 'png'],
      width: 0,
      height: 0,
    };
  },
  created() {
    EventBus.$on('cropper-open', (info) => {
      this.imgKey = info.key;
      this.imgSrc = info.url;
      this.width = info.width;
      this.height = info.height;

      setTimeout(() => {
        if (!this.imgSrc && this.$refs.input) {
          this.$refs.input.click();
        }
      });
    });
  },
  methods: {
    closePopup(e) {
      this.show = e.target.className !== 'popup popup-cropper';

      if (!this.show) {
        this.cropInit();
      }
    },
    confirm() {
      const self = this;

      if (self.imgSrc) {
        self.cropImage();

        EventBus.$emit('insertCropImage', {
          key: self.imgKey,
          url: self.cropImg,
        });

        self.cropInit();
      }

      self.show = false;
    },
    cropInit() {
      this.imgSrc = '';
      this.cropImg = '';

      if (this.$refs.input) {
        this.$refs.input.value = '';
      }
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      // this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.cropImg = this.$refs.cropper
        .getCroppedCanvas({
          width: this.width, // [A] 저화질
          height: this.height, // [A] 저화질
          // minWidth: this.width, // [B] 고화질
          // minHeight: this.height, // [B] 고화질
          maxWidth: 4096, // [B] 고화질
          maxHeight: 4096, // [B] 고화질
          fillColor: 'transparent',
          imageSmoothingEnabled: false,
          imageSmoothingQuality: 'high',
        })
        .toDataURL('image/jpeg');
    },
    flipX() {
      const dom = this.$refs.flipX;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleX(scale);
      dom.setAttribute('data-scale', scale);
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute('data-scale');
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute('data-scale', scale);
    },
    getCropBoxData() {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4);
    },
    getData() {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    setCropBoxData() {
      if (!this.data) return;
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data));
    },
    setData() {
      if (!this.data) return;
      this.$refs.cropper.setData(JSON.parse(this.data));
    },
    setImage(e) {
      const file = e.target.files[0];
      const fileType = file.type.split('/');
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (this.exts.indexOf(fileType[1]) === -1) {
        alert('Please select an bmp, jpg, jpeg, png file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    showFileChooser() {
      this.$refs.input.click();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    getCroppedCanvas() {
      /* 옵션 사용 예제 */
      const self = this;

      return self.cropper
        .getCroppedCanvas({
          width: 160,
          height: 90,
          minWidth: 256,
          minHeight: 256,
          maxWidth: 4096,
          maxHeight: 4096,
          fillColor: 'transparent',
          imageSmoothingEnabled: false,
          imageSmoothingQuality: 'high',
        })
        .toBlob((blob) => {
          const url = URL.createObjectURL(blob);
          const cropperResultImage = new Image();
          const formData = new FormData();

          cropperResultImage.src = url;

          EventBus.$emit('insertCropImage', {
            index: self.cropperIndex,
            image: cropperResultImage,
            url,
          });

          // Pass the image file name as the third parameter if necessary.
          formData.append('croppedImage', blob /* 'example.png' */);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.cropper-wrap {
  input[type='file'] {
    display: none;
  }

  textarea {
    width: 100%;
    height: 100px;
  }

  .content {
    display: flex;
    justify-content: space-between;
  }

  .cropper-area {
    width: 614px;
    border: 1px solid #ebebeb;
    border-top: 0 none;
    border-left: 0 none;
    background: url(~@assets/images/cropper/bg-pictures.png) no-repeat center
      center;
  }

  .preview-area {
    width: 307px;
    border-bottom: 1px solid #ebebeb;

    p {
      font-size: 1.25em;
      text-align: center;
      margin: 1em;
    }

    .preview {
      width: 100%;
      height: calc(372px * (9 / 16));
      overflow: hidden;
    }
  }

  .cropped-image {
    img {
      max-width: 100%;
    }

    .crop-placeholder {
      width: 100%;
      height: 200px;
      background: #ccc;
    }
  }

  .upload-image-btn {
    margin-right: 10px;
    color: rgba(0, 158, 255, 1);

    &:hover {
      color: rgba(0, 158, 255, 0.6);
    }
  }

  .button-box {
    display: flex;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 10px 0;

    > * {
      display: block;
      box-sizing: border-box;
      flex: 1 1 50%;
      height: 38px;
      border: 1px solid rgba(0, 158, 255, 1);
      font-size: 1.5em;
      line-height: 38px;
      text-align: center;
      text-decoration: none;
    }
  }

  .actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: 1em 0;
    padding: 10px;

    a {
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc((100% / 3) - 1em);
      padding: 5px 15px;
      border: 1px solid #009eff;
      background-color: #ffffff; // #009eff, rgba(0, 158, 255, 1)
      font-size: 1.25em;
      color: #009eff;
      text-decoration: none;
      margin: 0.5em;
    }

    a:hover {
      background-color: #009eff;
      color: #ffffff;
    }

    a::before {
      display: block;
      content: '';
      width: 14px;
      height: 14px;
      margin-right: 4px;
      background-repeat: no-repeat;
      background-position: 0 center;
      background-size: 100% 100%;
    }

    a.zoom-in::before {
      background-image: url(~@assets/images/cropper/icon-zoom-in.png);
    }

    a.zoom-out::before {
      background-image: url(~@assets/images/cropper/icon-zoom-out.png);
    }

    a.move-left::before {
      background-image: url(~@assets/images/cropper/icon-move-arrow.png);
      transform: rotate(-180deg);
    }

    a.move-right::before {
      background-image: url(~@assets/images/cropper/icon-move-arrow.png);
    }

    a.move-up::before {
      background-image: url(~@assets/images/cropper/icon-move-arrow.png);
      transform: rotate(-90deg);
    }

    a.move-down::before {
      background-image: url(~@assets/images/cropper/icon-move-arrow.png);
      transform: rotate(90deg);
    }

    a.rotate-plus::before {
      background-image: url(~@assets/images/cropper/icon-rotate.png);
      transform: rotate(90deg);
    }

    a.rotate-minus::before {
      background-image: url(~@assets/images/cropper/icon-rotate.png);
      transform: rotate(-180deg);
    }

    a.flip-x::before {
      background-image: url(~@assets/images/cropper/icon-flip.png);
    }

    a.flip-y::before {
      background-image: url(~@assets/images/cropper/icon-flip.png);
      transform: rotate(-90deg);
    }

    a.crop::before {
      background-image: url(~@assets/images/cropper/icon-crop-tool.png);
    }

    a.reset::before {
      background-image: url(~@assets/images/cropper/icon-reset.png);
    }

    a.upload-image::before {
      background-image: url(~@assets/images/cropper/icon-upload.png);
    }
  }
}

.popup.popup-cropper {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding-top: 40px; // Custom Property

  .popup-container {
    max-width: 480px;
    width: 100%;
    margin: 12px;
    background-color: $white;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;

    .popup-header {
      width: 100%;
      height: 56px;
      padding: 0 16px;
      border-bottom: 1px solid $gray-eb;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      h2 {
        font-size: 16px;
        color: $gray-33;
      }

      .icon.close {
        width: 15px;
        height: 15px;
        margin: auto 0;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 16px;
        background-image: url(~@assets/images/icon-close.png);
        background-color: transparent;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100%;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        border-radius: 10px;
      }
    }

    .popup-body {
      width: 100%;

      .video-preview {
        width: 100%;
        height: 100%;
        padding: 12px;
        overflow: hidden;

        video {
          width: 100%;
          height: 100%;
          min-width: 100%;
          min-height: 100%;
          object-fit: contain;
        }
      }

      .image-box {
        width: 100%;
        height: 100%;
        padding: 12px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          min-width: 100%;
          min-height: 100%;
          object-fit: contain;
        }
      }
    }

    .popup-footer {
      width: 100%;
      height: 88px;
    }
  }
}

.popup-body {
  width: calc(100% - 92px);

  .image-row {
    width: 100%;
    height: 100%;

    .canvas {
      width: 100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        max-width: 100%;
        max-height: 100%;
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        object-fit: contain;
      }
    }
  }

  .button-row {
    margin-top: 12px;

    .button {
    }
  }

  .text-row {
    margin-top: 12px;

    ul {
      display: inline-flex;
      border-bottom: 1px solid $gray-e6;

      li {
        cursor: pointer;
        text-align: center;

        span {
          font-size: 16px;
          color: $primary;
        }
      }

      li + li {
        margin-left: 18px;
      }
    }
  }
}
</style>
